import React, { useCallback } from 'react';
import styles from './YourChildAge.module.css';
import { MobileStepIndicator } from '../../../../component/signup/mobileStepIndicator/mobileStepIndicator';
import { useAppSelector } from '../../../../store/hooks';
import { YourChildAgeElement } from '../YourChildAgeElement';

export const MobileView = (): JSX.Element => {
  // Redux Hooks

  const yourChildAgeElement = YourChildAgeElement();
  return (
    <React.Fragment>
      <div className={styles.yourChildAge}>
        <header className={styles.headerGroup} id="common-navi-bar">
          <img
            className={styles.bbaLogoIcon}
            id="entry-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
        </header>
        <main className={styles.yourChildAgeMainGroupDiv}>
          <div
            className={styles.yourChildAgeTitleGroupDiv}
            onClick={yourChildAgeElement.backButtonClickHandler}
          >
            <img
              className={styles.mobileBackIcon}
              id="mobile-back-icon"
              alt=""
              src="assets/common/mobile-back-icon.svg"
            />
            <div className={styles.yourChildAgeTitleDiv}>
              Select&nbsp;a&nbsp;Level
            </div>
          </div>
          <div className={styles.yourChildAgeSelectGroupDiv}>
            <div className={styles.weProvideTheBestLearningM}>
              <p className={styles.weProvideThe}>
                We provide the best learning materials for your kids based on
                their age range.
              </p>
            </div>
            <div className={styles.yourChildAgeSelectAge3Icon}>
              {yourChildAgeElement.ageSelect}
            </div>
            <div className={styles.yourChildAgeSelectNextButButton}>
              {yourChildAgeElement.continueButton}
            </div>
          </div>
        </main>
        <footer className={styles.progressIndicatorsFooter}>
          <MobileStepIndicator step={3} totalStep={4} />
        </footer>
      </div>
    </React.Fragment>
  );
};
